import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoVehiculoService extends CrudService<any> {
  endpointPublic: string = environment.endpointPublic;

  constructor(private config: AppConfigService, http: HttpClient) {
    super(config.TipoVehiculoUrl, http);
  }
    get_lista_venta_rapida(): Observable<any> {
      let url = `${this.config.VentaRapidaUrl}/tipos`;
    return this.http.get<any>(url);
  }

}
